import {
  GET_PLAN_LIMITS_BEGIN,
  GET_PLAN_LIMITS_SUCCESS,
  GET_PLAN_LIMITS_FAILURE,
} from '../_types'
import plans from '@api/plans'

const getDefaultState = () => {
  return {
    // volume limits
    domains: {
      current: 0,
      limit: 1,
    },
    campaigns: {
      current: 0,
      limit: 1,
    },
    pageViews: {
      current: 0,
      limit: 1,
    },
    // feature toggles
    features: [],
    // response state
    getPlanLimitsLoading: false,
    getPlanLimitsCompleted: false,
    getPlanLimitsError: false,
  }
}
export const state = getDefaultState()

export const getters = {
  'isFeatureLimited.domains': (state) =>
    state.domains.current >= state.domains.limit && state.domains.limit >= 0,
  'isFeatureLimited.campaigns': (state) =>
    state.campaigns.current >= state.campaigns.limit && state.campaigns.limit >= 0,
  'isFeatureLimited.pageViews': (state) =>
    state.pageViews.current >= state.pageViews.limit && state.pageViews.limit >= 0,
}

export const mutations = {
  [GET_PLAN_LIMITS_BEGIN](state) {
    state.getPlanLimitsCompleted = false
    state.getPlanLimitsLoading = true
    state.getPlanLimitsError = false
  },
  [GET_PLAN_LIMITS_SUCCESS](state, data) {
    state.domains = data.domains
    state.campaigns = data.campaigns
    state.pageViews = data.pageViews
    state.features = data.features

    state.getPlanLimitsCompleted = true
    state.getPlanLimitsLoading = false
  },
  [GET_PLAN_LIMITS_FAILURE](state) {
    state.all = []
    state.getPlanLimitsError = true
    state.getPlanLimitsLoading = false
  },
}

export const actions = {
  getPlanLimits({ commit }, payload) {
    commit(GET_PLAN_LIMITS_BEGIN)

    return plans.getPlanLimits(payload).
      then((response) => commit(GET_PLAN_LIMITS_SUCCESS, response.data)).
      catch(() => commit(GET_PLAN_LIMITS_FAILURE))
  },
}
